import { render, staticRenderFns } from "./VButtonNext.vue?vue&type=template&id=1e896b65&scoped=true&"
var script = {}
import style0 from "./VButtonNext.vue?vue&type=style&index=0&id=1e896b65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e896b65",
  null
  
)

export default component.exports